export {
  // Layout & navigation
  cilAccountLogout,
  cilContrast,
  cilList,
  cilLockLocked,
  cilMenu,
  cilMoon,
  cilSettings,
  cilSpeech,
  cilSun,
  cilUser,
  // ERP modules
  cilArrowBottom,
  cilArrowTop,
  cilCalendar,
  cilCart,
  cilCheck,
  cilCloudDownload,
  cilCloudUpload,
  cilCopy,
  cilDescription,
  cilFile,
  cilFolder,
  cilFolderOpen,
  cilHome,
  cilLocationPin,
  cilNotes,
  cilPencil,
  cilPeople,
  cilPlus,
  cilSearch,
  cilSpreadsheet,
  cilTags,
  cilTrash,
  cilTruck,
  // New module icons
  cilBell,
  cilGift,
  cilGrid,
  cilImage,
  cilLayers,
  cilChart,
  cilMap,
  cilStar,
  cilBike,
  cilBadge,
  cilCommentSquare,
} from '@coreui/icons';
